import {
    IIndoorFloorTrapAudit,
    IIndoorFlyingTrapAudit,
    IOutdoorTrapAudit,
} from "@/types/audit";

export enum InspectionOutcome {
    positive = 'POSITIVE',
    negative = 'NEGATIVE',
}

export interface IInspection {
    id: number,
    costumer: number,
    date: string,
    repellent_product?: string,
    costumer_sign?: string,
    costumer_sign_url?: string,
    outdoor_audits: IOutdoorTrapAudit[],
    indoor_floor_audits: IIndoorFloorTrapAudit[],
    indoor_flying_audits: IIndoorFlyingTrapAudit[],
    outcome?: InspectionOutcome,
    non_compliance?: string,
    note: string,
}

export function compareInspectionDate(A: IInspection, B: IInspection) {
    const dateA: Date = new Date(A.date);
    const dateB: Date = new Date(B.date);

    if (dateA < dateB)
        return -1;
    else if (dateA == dateB)
        return 0;
    else // (dateA > dateB)
        return 1;
}
